import React, { useState } from "react";
import ChangeEmail from "./ChangeEmail";
import styles from "./changeEmail.module.scss";

interface ChangeEmailButtonProps {
  label: string;
}

export default function ChangeEmailButton({ label }: ChangeEmailButtonProps) {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const togglePopup = () => {
    setIsPopupOpen(!isPopupOpen);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
  };

  return (
    <div>
      <button onClick={togglePopup} className={styles.popupButton}>
        Edytuj
      </button>
      <ChangeEmail
        isOpen={isPopupOpen}
        onClose={closePopup}
        label={`Edytuj ${label}`}
      />
    </div>
  );
}
